/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", () =>
  $('[data-toggle="tooltip"], a[rel=tooltip]').tooltip()
)
